import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFilterContext } from '../contexts/filterContext'
import useModalLabels from '../hooks/useModalLabels'
import HyButton from './common/hy/HyButton'
import HyModal from './common/hy/HyModal'

type ResetFiltersButtonProps = {
  onReset?: () => void
  dataTestId?: string
  disabled?: boolean
}

const ResetFiltersButton = ({ onReset, dataTestId, disabled }: ResetFiltersButtonProps) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()
  const { resetFilters } = useFilterContext()
  const modalLabels = useModalLabels()

  const handleClose = () => {
    setOpen(false)
  }

  const handleConfirm = () => {
    resetFilters()
    onReset?.()
    handleClose()
  }

  return (
    <>
      <HyButton
        variant="supplementary"
        colour="blue"
        onClick={() => setOpen(true)}
        data-testid={dataTestId}
        disabled={disabled}
      >
        {t('v2:noRecommendations.resetButton')}
      </HyButton>

      <HyModal
        open={open}
        onClose={handleClose}
        labels={modalLabels}
        size="small"
        title={t('v2:noRecommendations.resetConfirmationTitle')}
        footer={
          <HyButton variant="primary" colour="black" onClick={handleConfirm}>
            {t('v2:noRecommendations.resetConfirmationConfirm')}
          </HyButton>
        }
      >
        {t('v2:noRecommendations.resetConfirmationDescription')}
      </HyModal>
    </>
  )
}

export default ResetFiltersButton
